
    <span class="form-control-plaintext border-bottom form-control-sm pl-2 record-texts long-text pre-wrap-text">
      {{ display$ | async }}
    </span>
  